import React from "react";
import ReactDOM from "react-dom";
import "./css/index.css";
import App from "./App";
import {BrowserRouter} from "react-router-dom";
import ScrollToTop from "./components/shared/ScrollToTop";
import { configureStore } from "./redux/configure-store";
import { Provider } from "react-redux";
import axios from "axios";
import TagManager from 'react-gtm-module'
import { createBrowserHistory } from "history";

import { createRoot } from 'react-dom/client';

// Setup base url - quick and dirty

let base = "https://landlord-extras-api.alanboswell.com";
let addressLookup = "https://addresslookup.alanboswell.com/addresslookup"
let gtm = "GTM-5KTB65"; // prod

const urlHost = document.location.hostname;

//console.log(`current host is ${urlHost} - gtmId = ${gtm}`);

if (urlHost === "lergb2c.devsite") {
  base = "http://lergb2c-api.devsite";
  addressLookup = "http://addresslookup.devsite/addresslookup"
  gtm = 'GTM-5KTB65';
} else if (urlHost === "beta-landlord-extras.alanboswell.com") {
  base = "https://beta-landlord-extras-api.alanboswell.com";
  addressLookup = "https://beta-addresslookup.alanboswell.com/addresslookup"
  gtm = 'GTM-5KTB65';
} else if (urlHost === "localhost") {
    base = "http://lergb2c-api.devsite";
    addressLookup = "http://addresslookup.devsite/addresslookup"
    //base = "http://localhost:5000";
    gtm = 'GTM-5KTB65';
}

axios.defaults.baseURL = base;
//console.log(`setting axios baseURL to ${base}, gtm = ${gtm}`);

const tagManagerArgs = {
  gtmId: gtm
}

export const addressLookupURL = addressLookup;

TagManager.initialize(tagManagerArgs);

export const history = createBrowserHistory();

const store = configureStore(history);
const container = document.querySelector("#root")
const root = createRoot(container!);
root.render(
  <Provider store={store as any}>
    <BrowserRouter>
      <ScrollToTop/>
      <App />
    </BrowserRouter>
  </Provider>
);
